import styled from "styled-components";

const Panel = styled.div`
  background-color: var(--panel);
  border-radius: 5px;
  border: var(--border) solid 1px;
  width: 100%;
  padding: 0.5rem;
`;
export default Panel;
